import { createAction, props } from '@ngrx/store';

import type { ErrorActionPayload, ResultActionPayload } from '@bp/shared/models/common';

import type { IIdentity } from '../models';

import type { IdentityApiActions } from './identity-api.actions';

export const IDENTITY_STATE_SCOPE = '[Domain][Identity]';

export const IDENTITY_STATE_API_SCOPE = `[API]${ IDENTITY_STATE_SCOPE }`;

export function composeIdentityApiActions<TIidentity extends IIdentity>(): IdentityApiActions<TIidentity> {
	return {
		loginSuccess: createAction(
			`${ IDENTITY_STATE_API_SCOPE } Login Success`,
			props<ResultActionPayload<TIidentity>>(),
		),

		loginFailure: createAction(`${ IDENTITY_STATE_API_SCOPE } Login Failure`, props<ErrorActionPayload>()),
	};
}
